import { API, Auth } from 'aws-amplify';

export const ARCHIVED_DATA = "archived_data";
export const ARCHIVED_WAVEFORMS = "archived_waveforms";
export const NUMERICS_BY_CSN = "numerics_by_csn";
export const PAST_NUMERICS_REFERENCE_RANGE_BY_MRN = "past_numerics_reference_range_by_mrn";
export const CHARTED_VITAL_SIGNS_BY_MRN = "charted_vital_signs_by_mrn";
export const MEDICATION_RESPONSE_BY_CSN = "medication_response_by_csn";
export const MEDICATIONS_BY_CSN = "medications_by_csn";
export const LABS_BY_CSN = "labs_by_csn";
export const HOME_MEDICATIONS_BY_MRN = "home_medications_by_mrn";
export const ORDERS_BY_CSN = "orders_by_csn";
export const ANNOTATIONS_BY_CSN = "annotations_by_csn";
export const ANNOTATIONS_EXTENSIONS_BY_CSN = "annotations_extensions_by_csn";
export const RADIOLOGY_REPORT_DETAILS_BY_ID = "radiology_report_details";
export const PATIENT_VISIT_BY_CSN = "patient_visit_by_csn";
export const PATIENT_VISIT_BY_INTERNAL_CSN = "patient_visit_by_internal_csn";
export const PATIENT_VISITS_BY_MRN_WITH_SUMMARY = "patient_visits_by_mrn_with_summary";
export const DIAGNOSES_BY_MRN = "diagnoses_by_mrn"
export const RELEVANT_COMPASS_DIAGNOSES_FOR_ACTIVE_PATIENTS = "relevant_compass_diagnoses_for_active_patients";
export const RELEVANT_COMPASS_DIAGNOSES_FOR_CDU_PATIENTS = "relevant_compass_diagnoses_for_cdu_patients";
export const ACTIVE_PATIENT_VISITS = "active_patient_visits";
export const ACTIVE_PATIENT_VISITS_WITH_METADATA = "active_patient_visits_with_metadata";
export const ACTIVE_PATIENT_VISITS_WITH_METADATA_V2 = "active_patient_visits_with_metadata_v2";
export const PATIENT_VISITS_WITH_METADATA_BY_ARRIVAL = "patient_visits_with_metadata_by_arrival";
export const CDU_PATIENT_VISITS_WITH_METADATA = "cdu_patient_visits_with_metadata";
export const PAST_FAVORITES_FOR_ACTIVE_PATIENTS = "past_favorites_for_active_patients";
export const PAST_FAVORITES_FOR_CDU_PATIENTS = "past_favorites_for_cdu_patients";
export const PAST_FAVORITES_FOR_COMPASS_PARTICIPANTS = "past_favorites_for_compass_participants";
export const ACTIVE_PATIENT_VISITS_AT = "active_patient_visits_at";
export const COMPASS_PATIENT_VISITS_WITH_METADATA = "compass_patient_visits_with_metadata";
export const COMPASS_ACCRUAL_PARTICIPANTS = "compass_accrual_participants";
export const COMPASS_ACCRUAL_VISITS_AFTER_INDEX = "compass_accrual_visits_after_index";
export const COMPASS_PAST_MEDICAL_HISTORY = "compass_past_medical_history";
export const COMPASS_PARTICIPANT_DETAILS = "compass_participant_details";
export const COMPASS_ALL_PATIENTS_ANNOTATIONS = "compass_all_patients_annotations";
export const COMPASS_ANNOTATIONS_BY_STUDY_ID = "compass_annotations_by_study_id";
export const COMPASS_DAILY_WEARING_DETECTION = "compass_daily_wearing_detection";
export const COMPASS_SURVEYS_BY_PARTICIPANT_ID = "compass_surveys_by_participant_id";
export const COMPASS_NUMERICS = "compass_numerics";
export const COMPASS_RAW_DATA = "compass_raw_data";
export const RISK_SCORES_FOR_CSN = "risk_scores_for_csn";
export const RISK_FEATURES_FOR_CSN = "risk_features_for_csn";
export const SCORES_BY_CSN = "scores_by_csn";
export const RECENT_PATIENT_VISITS = "recent_patient_visits";
export const FAVORITES_BY_USERNAME = "favorites_by_username";
export const CURRENT_DELAY = "current_delay";
export const GET_VISIT_METADATA = "get_visit_metadata";
export const DASHBOARD_METRICS = "dashboard_metrics";
export const GET_INSIGHTS_BY_CSN = "get_insights_by_csn";
export const LOCATIONS_BY_CSN = "locations_by_csn";
export const FAVORITES_FOR_USERNAME_AND_ACTIVE_PATIENTS = "favorites_by_username_and_active_patients";
export const FAVORITES_FOR_USERNAME_AND_TYPE = "favorites_by_username_and_type";
export const FAVORITES_BY_USERNAME_AND_CSN = "favorites_by_username_and_csn";
export const FAVORITE_LISTS_FOR_USERNAME = "favorite_lists_by_username";
export const NOTES_FOR_USERNAME_AND_CSN = "notes_by_username_and_csn";
export const NOTES_FOR_USERNAME_AND_MRN = "notes_by_username_and_mrn";
export const ADMIT_RISK_SCORES_FOR_ACTIVE_PATIENTS = "admit_risk_for_active_patients";
export const DOWNLOAD_ALL_FAVORITES = "download_all_favorites";
export const AFIB_GET_PATIENTS = "afib_get_patients";
export const LLM_DASHBOARD_GET_STATUS = "get_llm_dashboard_status";
export const LLM_DASHBOARD_QUERY_STATUS_BY_CSN = "query_llm_dashboard_status_by_csn";
export const LLM_VISIT_FEEDBACK_BY_CSN = "llm_visit_feedback_by_csn";
export const LLM_VISIT_FEEDBACK_SEARCH = "llm_visit_feedback_search";
export const LLM_VISIT_FEEDBACK_DOWNLOAD = "llm_visit_feedback_download";
export const LLM_ASSESSMENT_DOWNLOAD = "llm_assessment_download";
export const ACTIONABLE_ITEMS_FOR_VISIT = "actionable_items_for_visit";
export const ACTIONABLE_ANSWERS_BY_ITEM_ID = "actionable_answers_by_item_id";
export const NEXT_STEPS_BY_CSN = "next_steps_by_csn";
export const USER_EVENTS_TREND = "user_events_trend";
export const USER_EVENTS_RECENT_SESSIONS = "user_events_recent_sessions";
export const USER_EVENTS_SESSION_DETAILS = "user_events_session_details";
export const LLM_FILE_DIFF = "llm_file_diff";
export const UNREAD_EXPLAIN_JOBS = "unread_explain_jobs";
export const GET_FILE_AT_VERSION = "get_file_at_version";
export const GET_FOLLOWED_PATIENTS_BY_USERNAME = "get_followed_patients_by_username";
export const GET_FOLLOWED_PATIENTS_BY_USERNAME_WITH_FILTERS = "get_followed_patients_by_username_with_filters";
export const GET_FOLLOWED_PATIENTS_BY_USERNAME_WITH_ASSESSMENTS = "get_followed_patients_by_username_with_assessments";
export const GET_NUMBER_OF_INCOMPLETE_ASSESSMENTS = "get_number_of_incomplete_assessments";
export const GET_FOLLOWED_PATIENTS_BY_USERNAME_AND_CSN = "get_followed_patients_by_username_and_csn";
export const GET_LATEST_VERSIONS_FOR_CSN = "get_latest_versions_for_csn";
export const GET_ALL_VERSIONS_FOR_CSN_AND_FILE_TYPE = "get_all_versions_for_csn_and_file_type";
export const LIDIA_GET_CONVERSATION = "lidia_get_conversation";
export const LIDIA_GET_LATEST_CONVERSATION = "lidia_get_latest_conversation";
export const LIDIA_GET_ALL_PARTICIPANTS = "lidia_get_all_participants";
export const LIDIA_GET_ACTIVE_PARTICIPANTS = "lidia_get_active_participants";
export const LIDIA_GET_PARTICIPANT_DETAILS = "lidia_get_participant_details";
export const LIDIA_GET_ALERTS = "lidia_get_alerts";
export const LIDIA_GET_UNACKNOWLEDGED_ALERTS = "lidia_get_unacknowledged_alerts";

export const METRICS_FOR_BOARDING_REPORT = "metrics_for_boarding_report";
export const METRICS_FOR_REVISIT_REPORT = "metrics_for_revisit_report";
export const METRICS_TRENDS = "metrics_trends";
export const METRICS_HOUR_OF_DAY = "metrics_hour_of_day";
export const METRICS_DAY_OF_WEEK = "metrics_day_of_week";
export const METRICS_CURRENT_RELATIVE = "metrics_current_relative";
export const METRICS_PERCENTILE_RANK = "metrics_percentile_rank";
export const METRICS_CURRENT_RELATIVE_BOARDED = "metrics_current_relative_boarded";
export const METRICS_PERCENTILE_RANK_BOARDED = "metrics_percentile_rank_boarded";
export const METRICS_FORECAST_TRENDS = "metrics_forecast_trends";
export const FLOW_CHART_FOR_BOARDING_REPORT = "flow_chart_data_for_boarding_report";
export const USER_SETTINGS = "user_settings";
export const GET_USER_DATA_SUMMARY = "get_user_data_summary";
export const EXPORT_USER_DATA = "export_user_data";
export const GET_SYSTEM_BANNER = "get_system_banner";
export const GET_RELEASE_NOTES = "get_release_notes";

export interface Lab {
    "acquisition_time": number,
    "component_value": number | null,
    "component_unit": string,
    "component_result": string,
    "lab_group": string,
    "lab_name": string,
    "normal_range_low": number | null,
    "normal_range_high": number | null,
    "status": string,
}

export interface Medication {
    "action_time": string,
    "end_time": string,
    "action": string,
    "dose": number | null,
    "dose_unit": string,
    "med_name": string
}

export interface HomeMedication {
    order_date: string,
    start_date: string,
    med_name: string,
    atc_code?: string,
    status?: string,
    route?: string,
    sig?: string,
    as_needed?: string,
    patient_instruction?: string,
}

export interface Order {
    order_time: string,
    order_type: string,
    order_item_id: string,
}

export interface Insight {
    insight_id: number,
    creation_time: string,
    csn: string,
    mrn: string,
    category: string,
    title: string,
    description: string,
    rationale: string,
    severity: string,
    quality: string,
    status: string,
}

export interface Annotation {
    annotation_id: number,
    annotation_time: number,
    annotation_source: string,
    annotation_target: string,
    annotation_length_seconds: number,
    measure_name: string,
    measure_value: number,
}

export interface RiskScore {
    csn: string,
    prediction_time: number,
    prediction_type: string,
    prediction: number,
}

export interface RadiologyReport {
    imaging_id: number,
    csn: string,
    mrn: string,
    result_time: number,
    order_time: number,
    study: string,
    impression?: string,
    critical_gpt4?: string,
    critical_finding?: string,
}

export interface Diagnosis {
    noted_date: number,
    desc10: string,
    icd10: string,
    ccs: string,
    mrn: string,
    csn: string,
}

export interface PatientSummary {
    csn: string,
    mrn: string,
    llm_summary: string,
}

export interface Favorite {
    favorite_id: number,
    username: string,
    favorite_time: number,
    favorite_type: string,
    csn: string,
    mrn: string,
    internal_csn: string,
    internal_mrn: string,
}

export interface Note {
    note_id: number,
    username: string,
    creation_time: number,
    update_time: number,
    note_type: string,
    csn: string,
    mrn: string,
    note: string,
}

export interface LLMVisitFeedback {
    feedback_id: number,
    username: string,
    creation_time: Date,
    update_time: Date,
    csn: string,
    mrn: string,
    feedback_target: string,
    feedback_type: string,
    note: string,
}

export interface NextStep {
    id: number,
    csn: string,
    mrn: string,
    category: string,
    action: string,
    rationale: string,
    priority: string,
    status: string,
    creation_date: string,
    updated_date: string,
}

export interface Metric {
    metric_id: number,
    metric_name: string,
    hour_of_day: string,
    day_of_week: string,
    dimension_name: string,
    dimension_value: string,
    metric_time: number,
    metric_value: number,
}

export interface FollowedPatient {
    username: string;
    csn: string;
    follow_type: string; // 'MANUAL' or 'AUTO'
}

export interface LastViewedPatientFile {
    username: string;
    csn: string;
    file_type: string;
    last_viewed_at: string;
    last_viewed_version_id: string;
    last_viewed_version_date: string;
}

export interface PatientFileVersion {
    csn: string;
    file_type: string;
    version_id: string;
    version_date: string;
    source_version_id: string;
    source_version_date: string;
    source_changed_keys: string[];
}

export interface TrackboardColumn {
    id: string;
    show: boolean;
}

export interface SystemBanner {
    id: string;
    message?: string;
    variant?: 'info' | 'warning' | 'danger';
    isActive?: boolean;
    createdAt?: number;
    updatedAt?: number;
}

export interface ReleaseNote {
    pk: string;              // Fixed partition key: "RELEASE_NOTE"
    createdAt: number;       // Unix timestamp ms (sort key)
    title: string;
    description: string;
    version: string;
    updatedAt?: number;
    createdBy: string;
    stage: string;
}

export interface UserSettings {
    csn: string;
    trackboard_columns?: TrackboardColumn[];
    trackboard_columns_by_zone?: Record<string, TrackboardColumn[]>;
    is_presentation?: boolean;
    assumed_role?: string;
    schema_version?: string;
    user_agreement_version?: string;
    system_banner?: SystemBanner;
}

export interface ConversationStatus {
    phone_number: string;
    csn: string;
    last_activity: string;
    last_activity_time: string;
    queued_messages: any[];
    conversation_history: any[];
    created_at: string;
    message_count: number;
    error_count: number;
}

export interface LidiaParticipant {
    row_id: number;
    study_id: string;
    participant_type?: string;
    csn: string;
    mrn: string;
    enrollment_date: string;
    end_date?: string | null;
    last_activity_date?: string | null;
    status: 'ACTIVE' | 'WITHDRAWN' | 'COMPLETED';

    // Cached conversation data from RDS
    phone_number?: string | null;
    conversation_state?: 'IDLE' | 'IN_PROGRESS' | 'CLOSED' | null;
    message_count?: number;
    sent_count?: number;
    received_count?: number;
    last_conversation_activity?: string | null;
    error_count?: number;
    last_error?: string | null;

    // Alerts
    unacknowledged_alerts?: number;
    last_alert_timestamp?: string | null;
}

export interface LidiaConversation {
    phone_number: string;
    csn: string;
    mrn: string;
    conversation_state: 'IDLE' | 'IN_PROGRESS' | 'CLOSED';
    last_activity: string;
    last_activity_time: string;
    message_count: number;
    sent_count: number;
    received_count: number;
    error_count: number;
    last_error?: string | null;
    created_at: string;
    wr_conversation_started: boolean;
    last_message_types_sent?: Record<string, string>;
}

export interface LidiaAlert {
    alert_id: number;
    study_id: string;
    csn: string;
    mrn: string;
    alert_category: 'SAFETY' | 'PROTOCOL' | 'ENGAGEMENT' | 'DATA_QUALITY' | 'ADMINISTRATIVE' | 'POSITIVE';
    alert_type: string;
    severity?: 'critical' | 'high' | 'medium' | 'low' | 'info' | null;
    alert_title: string;
    alert_message: string;
    context_message?: string | null;
    alert_source: 'LLM_AUTOMATED' | 'COORDINATOR_MANUAL' | 'SYSTEM_RULE';
    triggered_by?: string | null;
    acknowledged_at?: string | null;
    acknowledged_by?: string | null;
    acknowledgment_notes?: string | null;
    resolution_action?: string | null;
    conversation_phase?: 'WR' | 'ROOM' | 'PDM' | null;
    created_at: string;
    updated_at: string;
}

// Legacy type alias for backwards compatibility during migration
export type LidiaSafetyAlert = LidiaAlert;

export interface LidiaParticipantDetails extends LidiaParticipant {
    conversations: LidiaConversation[];
    fhir_id?: string;
    alerts?: LidiaAlert[];
}

export interface LidiaSMSMessage {
    role: 'LIDIA' | 'PATIENT';
    content: string;
    timestamp: string;
    metadata?: {
        questions?: any[];
        rationale?: string;
        wait_time?: number;
        response_type?: string;
        expect_patient_reply?: 'yes' | 'no';
    };
    message_type?: 'WR' | 'ROOM' | 'PDM' | 'ACTIONABLE_ITEM' | 'NEXT_STEP';
}

export interface LidiaEnrollmentFormData {
    csn: string;
    mrn: string;
    phone_number?: string;
    status?: 'ACTIVE' | 'WITHDRAWN' | 'COMPLETED';
}

const is403Error = (err: any) => {
    if (!err?.errors || !Array.isArray(err.errors)) return false;

    return err.errors.some((error: any) => {
        // AppSync typically uses this errorType for unauthorized
        if (error.errorType === 'Unauthorized') return true;

        // Sometimes you might get a raw status code message
        if (error.message && error.message.includes('status code 403')) return true;

        // Some setups return 'Not Authorized' messages
        if (error.message && error.message.includes('Not Authorized')) return true;

        return false;
    });
};

let isSigningOut = false;

const handle403Error = async () => {
    if (isSigningOut) return; // Prevent multiple sign-outs
    isSigningOut = true;

    // Save reason to localStorage (or sessionStorage)
    localStorage.setItem('signOutReason', 'Your session expired or you are not on the Stanford network (if VPN, the VPN Group must be set to Cardinal-Full or Stanford-Full).');

    try {
        await Auth.signOut();
        window.location.reload();
    } catch (signOutError) {
        console.error('Error signing out user', signOutError);
    }
};

export const callQuery = async (input: any) => {
    try {
        const response: any = await API.post('EDPlatformFrontendAPI', '/api/query', {
            body: input,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return JSON.parse(response.response);
    } catch (err: any) {
        console.error("An error occurred while calling query", err);

        if (is403Error(err)) {
            await handle403Error();
        }

        return {};
    }
}
